import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSend, FiMessageSquare, FiRefreshCw } = FiIcons;

const AIChat = () => {
  const [messages, setMessages] = useState([
    { id: 1, text: "Hello! I'm your AI assistant. How can I help you today?", sender: 'ai' },
  ]);
  const [input, setInput] = useState('');

  const handleSend = () => {
    if (input.trim() === '') return;

    const newMessages = [...messages, { id: messages.length + 1, text: input, sender: 'user' }];
    setMessages(newMessages);
    setInput('');

    // Simulate AI response
    setTimeout(() => {
      setMessages(prev => [
        ...prev,
        { id: prev.length + 1, text: 'This is a simulated response. The full chat functionality is under development.', sender: 'ai' },
      ]);
    }, 1000);
  };

  const handleReset = () => {
    setMessages([
      { id: 1, text: "Hello! I'm your AI assistant. How can I help you today?", sender: 'ai' },
    ]);
  };

  return (
    <div className="bg-gray-800 text-white min-h-[calc(100vh-120px)] flex flex-col">
      {/* Header */}
      <div className="p-6 border-b border-gray-700">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center justify-between"
        >
          <div className="flex items-center space-x-3">
            <SafeIcon icon={FiMessageSquare} className="w-8 h-8 text-brand-secondary" />
            <div>
              <h1 className="text-2xl font-bold">AI Chat</h1>
              <p className="text-sm text-gray-400">Your intelligent assistant for any query.</p>
            </div>
          </div>
          <button
            onClick={handleReset}
            className="flex items-center space-x-2 px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
          >
            <SafeIcon icon={FiRefreshCw} className="w-4 h-4" />
            <span>New Chat</span>
          </button>
        </motion.div>
      </div>

      {/* Chat Area */}
      <div className="flex-1 p-6 overflow-y-auto">
        <div className="space-y-6">
          {messages.map((message) => (
            <motion.div
              key={message.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              className={`flex items-start gap-3 ${message.sender === 'user' ? 'justify-end' : ''}`}
            >
              {message.sender === 'ai' && (
                <div className="w-8 h-8 bg-brand-primary rounded-full flex-shrink-0" />
              )}
              <div
                className={`max-w-lg px-4 py-3 rounded-xl ${
                  message.sender === 'user'
                    ? 'bg-brand-secondary text-white'
                    : 'bg-gray-700 text-gray-300'
                }`}
              >
                <p className="text-sm">{message.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Input Area */}
      <div className="p-6 border-t border-gray-700">
        <div className="flex items-center space-x-4 bg-gray-700 p-2 rounded-lg">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            placeholder="Type your message here..."
            className="flex-1 bg-transparent focus:outline-none text-white placeholder-gray-400 px-2"
          />
          <button
            onClick={handleSend}
            className="bg-brand-secondary hover:bg-brand-tertiary text-white p-3 rounded-lg transition-colors"
          >
            <SafeIcon icon={FiSend} className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIChat;